import _ from 'underscore';

const hash = {};

const get = key => (hash[key] || '');

const set = (key /* key or object */, value) => {
  if (_.isString(key)) {
    hash[key] = value;
  } else if (_.isObject(key)) {
    _.extend(hash, key);
  }
};

const has = key => _.has(hash, key);

export const getConfig = (value) => {
  set(value);
  return {
    hash,
    get,
    set,
    has,
  };
};
